export default __webpack_public_path__ + "static/media/blog_post.964a2eed.svg";